import { render, staticRenderFns } from "./ResultsInOnIf.vue?vue&type=template&id=8f63907c&"
import script from "./ResultsInOnIf.vue?vue&type=script&lang=js&"
export * from "./ResultsInOnIf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports